import React from "react";
import { IconList, IconName } from "./icons";

interface IconProps {
  /**
   * Icon name
   */
  icon: IconName;
  /**
   * Color
   */
  color?: string;
  /**
   * Size
   */
  size?: number;
}

const Icon: React.FC<IconProps> = ({
  icon = "search",
  color = "#1F1F1F",
  size = 24,
}) => {
  const IconElement = IconList[icon];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <IconElement color={color} />
    </svg>
  );
};

export default Icon;
